<div class="modal-container">
  <!-- Header -->
  <div class="modal-header">
    <h2 class="modal-title">Información Contratante</h2>
    <button type="button" class="btn-close" (click)="cerrar()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Tabs Material -->
  <mat-tab-group [(selectedIndex)]="tabSeleccionadoIndex" animationDuration="300ms">
    <!-- TAB 1: RESULTADOS BÚSQUEDA -->
   
   <!-- TAB 1: RESULTADOS BÚSQUEDA -->
 <mat-tab label="RESULTADOS BÚSQUEDA">
      <div class="modal-body">
        <div class="row-resultados" [class.row-resultados-single]="!mostrarSeccionEPS && condicionAsociado.length === 0">
          
          <div class="columna-izquierda">
            
            <div class="seccion-resultado">
              <h4 class="titulo-seccion">Historial del cliente:</h4>
              <div class="alerta-container">
                <div *ngFor="let alerta of historialCliente" class="alerta-item" [ngClass]="alerta.tipo === 'error' ? 'alerta-error' : (alerta.tipo === 'info' ? 'alerta-info' : 'alerta-success')">
                  <mat-icon [ngClass]="alerta.tipo === 'error' ? 'icono-alerta' : (alerta.tipo === 'info' ? 'icono-info' : 'icono-check')">{{alerta.tipo === 'error' ? 'warning' : (alerta.tipo === 'info' ? 'info' : 'check_box')}}</mat-icon>
                  <p class="texto-alerta">{{alerta.mensaje}}</p>
                </div>
                <p *ngIf="historialCliente.length === 0" class="texto-alerta text-muted">No se encontraron antecedentes registrados en AFILMED para este usuario.</p>
              </div>
            </div>

            <div *ngIf="consultasPrevias.length > 0" class="seccion-resultado mt-3">
              <h4 class="titulo-seccion">Consultas previas (últimos 7 meses):</h4>
              <div class="alerta-container">
                <div *ngFor="let item of consultasPrevias" class="alerta-item" [ngClass]="item.tipo === 'error' ? 'alerta-error' : (item.tipo === 'info' ? 'alerta-info' : 'alerta-success')">
                  <mat-icon [ngClass]="item.tipo === 'error' ? 'icono-alerta' : (item.tipo === 'info' ? 'icono-info' : 'icono-check')">{{item.tipo === 'error' ? 'warning' : (item.tipo === 'info' ? 'info' : 'check_box')}}</mat-icon>
                  <p class="texto-alerta">{{item.mensaje}}</p>
                </div>
              </div>
            </div>

          </div>

          <div class="columna-derecha">
            
            <div class="seccion-resultado" *ngIf="mostrarSeccionEPS">
              <h4 class="titulo-seccion">Estado en EPS:</h4>
              <div class="alerta-container">
                <div *ngFor="let eps of estadoEPS" class="alerta-item" [ngClass]="eps.tipo === 'error' ? 'alerta-error' : 'alerta-success'">
                  <mat-icon [ngClass]="eps.tipo === 'error' ? 'icono-alerta' : 'icono-check'">{{eps.tipo === 'error' ? 'error' : 'check_box'}}</mat-icon>
                  <p class="texto-alerta">{{eps.mensaje}}</p>
                </div>
              </div>
            </div>

            <div *ngIf="condicionAsociado.length > 0" class="seccion-resultado" [class.mt-3]="mostrarSeccionEPS">
              <h4 class="titulo-seccion">Condición de asociado:</h4>
              <div class="alerta-container">
                <div *ngFor="let item of condicionAsociado" class="alerta-item" [ngClass]="item.tipo === 'error' ? 'alerta-error' : 'alerta-success'">
                  <mat-icon [ngClass]="item.tipo === 'error' ? 'icono-alerta' : 'icono-check'">{{item.tipo === 'error' ? 'warning' : 'check_box'}}</mat-icon>
                  <p class="texto-alerta">{{item.mensaje}}</p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button *ngIf="mostrarPestanaProgramas" type="button" class="btn-modal btn-elegir-programas" (click)="tabSeleccionadoIndex = 1">
          ELEGIR PROGRAMAS
        </button>
        <button type="button" class="btn-modal btn-guardar" *ngIf="!esPrecargaVisualFAEM" (click)="guardar()">
          GUARDAR
        </button>
      </div>
    </mat-tab>

    <!-- TAB 2: ELECCIÓN PROGRAMA (solo si el contratante es usuario) -->
    <mat-tab *ngIf="mostrarPestanaProgramas" label="ELECCIÓN PROGRAMA">
      <!-- Selector de Línea de Negocio -->
      <div class="selector-linea-negocio">
        <p class="label-selector">Selecciona la <strong>Línea de Negocio</strong></p>
        <div class="botones-linea-container">
          <button 
            *ngFor="let linea of lineasNegocioDisponibles"
            type="button"
            class="btn-linea-negocio"
            [class.btn-linea-seleccionada]="esLineaSeleccionada(linea.codigo)"
            (click)="toggleLinea(linea.codigo)">
            {{linea.nombre}}
          </button>
        </div>
      </div>

      <!-- Sección de Validación de Cobertura CEM (solo cuando hay programa CEM seleccionado) -->
      <div class="validacion-cobertura-container" *ngIf="hayProgramaCemSeleccionado && !esPrecargaIncompleta">
      <app-validacion-area-cobertura
        (coberturaValidaChange)="coberturaCemValida = $event">
      </app-validacion-area-cobertura>
    </div>

      <!-- Grid de Programas con Imágenes -->
      <div class="modal-body">
        <p class="label-selector mb-3">Selecciona el <strong>Programa</strong></p>
        
        <!-- Contenedor horizontal para las líneas de negocio -->
        <div class="contenedor-lineas-horizontal">
          <!-- Cada línea de negocio tiene su propio grid interno de 3 columnas -->
          <div *ngFor="let grupo of programasAgrupadosPorLinea; let last = last" class="grupo-linea-negocio">
            <h3 class="titulo-linea-negocio">{{grupo.nombre}}</h3>
            <div class="programas-grid">
              <mat-card *ngFor="let programa of grupo.programas" 
                        class="programa-card" 
                        [class.programa-seleccionado]="esProgramaSeleccionado(programa.id)"
                        (click)="toggleProgramaSeleccion(programa)">
                <mat-card-content>
                  <div class="programa-imagen">
                    <!-- Mostrar imagen del carnet si está disponible, sino mostrar placeholder -->
                    <img *ngIf="programa.carnet" 
                         [src]="programa.carnet" 
                         [alt]="programa.nombre"
                         class="programa-carnet-img">
                    <div *ngIf="!programa.carnet" 
                         class="programa-placeholder" 
                         [style.background]="programa.color">
                    </div>
                  </div>
                  <div *ngIf="esProgramaSeleccionado(programa.id)" class="check-overlay">
                    <mat-icon color="primary">check_circle</mat-icon>
                  </div>
                  <!-- Nombre del programa debajo de la imagen -->
                  <div class="programa-nombre-container">
                    <p class="programa-nombre-texto">{{programa.nombre}}</p>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>

        <!-- Sección de Configuración por Programa Seleccionado -->
        <div *ngIf="programasSeleccionados.length > 0 && !esPrecargaVisualFAEM" class="seccion-configuracion">
          <div *ngFor="let programaSel of programasSeleccionados; let i = index" class="config-programa">
            <h4 class="config-titulo">PROGRAMA {{(programaSel.nombre || '').toUpperCase()}}:</h4>
            <div class="config-anexos" *ngIf="shouldShowRequiereAnexo(programaSel)">
              <div class="anexos-label">
                ¿Requiere incluir anexos? *
              </div>

              <mat-radio-group
                [(ngModel)]="programaSel.requiereAnexo"
                (ngModelChange)="onRequiereAnexoChange(programaSel)"
                class="anexos-radio-group"
                aria-label="Requiere incluir anexos">
                <mat-radio-button value="si" class="me-3">Sí</mat-radio-button>
                <mat-radio-button value="no">No</mat-radio-button>
              </mat-radio-group>
            </div>
            
            <div class="config-row">
              <div class="config-col" *ngIf="esFlujoColectivoOGA">
                <label class="config-label">SUBCUENTA</label>
                <mat-form-field appearance="outline" class="config-field">
                  <mat-select [(ngModel)]="programaSel.subcuenta" 
                              placeholder="Seleccione" 
                              (selectionChange)="onSubcuentaChange(programaSel)" 
                              [disabled]="isSubcuentaDisabled(programaSel)">
                    <mat-option *ngFor="let deno of programaSel.subcuentasDisponibles" [value]="deno">
                      {{ getSubcuentaLabel(programaSel.id, deno) }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <small class="config-hint-tarifa" *ngIf="getSubcuentaHintMessage(programaSel)">
                  {{ getSubcuentaHintMessage(programaSel) }}
                </small>
              </div>

              <div class="config-col">
                <label class="config-label">TARIFA PROGRAMA</label>

                <mat-form-field appearance="outline" class="config-field">
                  <mat-select
                    [(ngModel)]="programaSel.tarifa"
                    placeholder="Seleccione"
                    (selectionChange)="onTarifaChange(programaSel)"
                    [disabled]="
                      isTarifaSelectDisabled(programaSel) ||
                      isTarifaBloqueadaPorInclusion(programaSel)
                    ">

                    <mat-option
                      *ngIf="!programaSel.tarifa"
                      [value]="">
                      Seleccione
                    </mat-option>

                    <mat-option
                      *ngFor="let t of programaSel.tarifasDisponibles"
                      [value]="t.tarifa">
                      {{ t.descripcion || t.description || t.tarifa }}
                    </mat-option>

                  </mat-select>
                </mat-form-field>

                <small
                  class="config-hint-tarifa"
                  *ngIf="getTarifaHintMessage(programaSel)">
                  {{ getTarifaHintMessage(programaSel) }}
                </small>
              </div>

              <div class="config-col" *ngIf="shouldShowTarifaAnexo(programaSel)">
                <label class="config-label">TARIFA ANEXO</label>
                <mat-form-field appearance="outline" class="config-field">
                  <mat-select [(ngModel)]="programaSel.anexoCodigo" placeholder="Seleccione"
                              (selectionChange)="onTarifaAnexoChange(programaSel, $event.value)">
                    <mat-option [value]="">Seleccione</mat-option>
                    <mat-option *ngFor="let an of (programaSel.anexosDisponibles || [])" [value]="anexoClaveCompuesta(an)">
                      {{ an.nombre }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="config-col">
                <label class="config-label">
                  CAMPAÑA
                  <mat-icon
                    class="icono-ayuda-campania"
                    #tooltipCampania="matTooltip"
                    [matTooltip]="getCampaniaTooltip(programaSel)"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!programaSel.campana"
                    (click)="tooltipCampania.toggle()"
                    tabindex="0">
                    priority_high
                  </mat-icon>
                </label>
                <mat-form-field appearance="outline" class="config-field">
                  <mat-select [(ngModel)]="programaSel.campana" placeholder="Seleccione" (selectionChange)="actualizarProgramasContratanteLocalStorage()" [disabled]="isCampanaSelectDisabled(programaSel) || isCampanaBloqueadaPorInclusion(programaSel)">
                    <mat-option [value]="" *ngIf="!programaSel.campana">Seleccione</mat-option>
                    <mat-option *ngFor="let c of programaSel.campaniasDisponibles" [value]="c.codigo_campania">
                      {{ c.nombre }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <small class="config-hint-tarifa" *ngIf="getCampanaHintMessage(programaSel)">
                  {{ getCampanaHintMessage(programaSel) }}
                </small>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Footer Tab Programas -->
      <div class="modal-footer">
        <button 
          type="button"
          class="btn-modal btn-guardar"
          *ngIf="!esPrecargaVisualFAEM"
          [disabled]="programasSeleccionados.length === 0
            || configuracionProgramasIncompleta
            || tieneColectivoSinSubcuenta"
          (click)="guardarProgramas()">
          GUARDAR
        </button>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
